import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Heading1 from "@components/layout/Heading";
import { useAdhocReport } from "@context/AdhocReportContext";

/**
 * The DEQ-style closing step after a template is saved. Saving a snapshot
 * does not come here — it lands on Report history, where the snapshot now
 * lives, exactly as DEQ does.
 */
const StepCompleted: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { templateName } = useAdhocReport();
  const name = templateName ?? "";

  return (
    <div className="flex flex-col grow">
      <div className="p-4 flex flex-col gap-4 grow">
        <Heading1 light>{t("reporting.general_step5_title")}</Heading1>
        <p className="text-sm">
          {t("reporting.template_saved_body", { name })}
        </p>
      </div>
      <footer className="flex gap-4 p-6 border-t border-gray-200 mt-auto">
        <Link className="btn-primary" to="/polestar/reports/adhoc">
          {t("reporting.back_to_reports")}
        </Link>
        <Link
          className="btn-outline-primary"
          to="/polestar/reports/adhoc/new"
          reloadDocument
        >
          {t("reporting.new_general_report")}
        </Link>
      </footer>
    </div>
  );
};

export default StepCompleted;
